<router-outlet id="hallHeaderOutlet" name="hallHeaderOutlet"></router-outlet>
<hall-header class="block sticky top-0 z-30"></hall-header>
<breadcrumb class="hall-breadcrumbs block w-full mt-3"></breadcrumb>
<!-- BANNER 1 -->
@defer(when usersService.userAction()) {
  <carousel-banner
    carouselId="hall-carousel"
    class="w-full h-[120px] border-b border-gray-400 bg-gray-100 sticky top-[64px] lg:top-[380px] z-10"
    adUnit="/21791770962/dfp_exp_home_test"
    [targeting]="currentCategory.parent ? currentCategory.parent.adManagerKey : currentCategory.adManagerKey"
    [subTargeting]="currentCategory.parent ? currentCategory.adManagerKey : null" />
}
@placeholder {
  <div class="h-[120px] w-full border-b border-gray-400 bg-gray-100 "></div>
}
<!--END BANNER 1 -->
<div class="w-full flex flex-col items-center z-0">
  <div class="container min-h-[101vh]">
    <div #content [ngClass]="showMore && content.scrollHeight > 157 ? 'overflow-visible h-auto' : 'h-[157px] overflow-hidden'">
      <div class="flex flex-row justify-between items-start mt-5 gap-5">
        <div class="w-full">
          <h1 class="text-3xl md:text-4xl lg:text-5xl">{{currentCategory.mainHeader}}</h1>
          @for (subHeader of currentCategory.subHeaders; track $index) {
            @if (subHeader.title) {
              <h2 class="text-2xl md:text-3xl mt-2">{{subHeader.title}}</h2>
            }
            @if (subHeader.text) {
              <p class="text-lg md:text-xl block" [innerHTML]="subHeader.text"></p>
            }
          }
        </div>
        <call-to-action class="hidden md:block" [withHeader]="false" [blackHeader]="true"></call-to-action>
      </div>
    </div>
    <button class="text-primary-A700 cursor-pointer bg-transparent p-0 border-none hover:underline" 
      [ngClass]="content.scrollHeight < 157 ? 'hidden' : ''" (click)="showMore = !showMore" i18n [innerText]="showMore ? 'Show less' : 'Show more'"></button>
    <router-outlet></router-outlet>
  </div>
</div>

